import { gql } from '@apollo/client'

/**
 * ESS 전체 조회
 */
export const findAllESSGQL = gql`
  query findAllESS {
    findAllESS {
      _id
      ESS_name
      batteryCapKWh
      pcsCapKW
      analysisPeriodYears
      capex {
        total
      }
      opex {
        inputMode
        total
      }
    }
  }
`

/**
 * ESS 단건 조회
 */
export const findOneESSGQL = gql`
  query findOneESS($val: String!) {
    findOneESS(_id: $val) {
      _id
      ESS_name
      batteryCapKWh
      pcsCapKW
      analysisPeriodYears
      capex {
        total
        option {
          optionId
          name
          unit
          value
          order
        }
      }
      opex {
        inputMode
        total
        option {
          optionId
          name
          unit
          value
          order
        }
      }
      createdAt
      updatedAt
      deletedAt
    }
  }
`

/**
 * ESS 생성
 */
export const createESSGQL = gql`
  mutation createESS($val: CreateEssInput!) {
    createESS(createESSInput: $val) {
      _id
      ESS_name
      batteryCapKWh
      pcsCapKW
      analysisPeriodYears
      createdAt
    }
  }
`

/**
 * ESS 수정
 */
export const updateESSGQL = gql`
  mutation updateESS($val: UpdateEssInput!) {
    updateESS(updateESSInput: $val) {
      _id
      ESS_name
      batteryCapKWh
      pcsCapKW
      analysisPeriodYears
      updatedAt
    }
  }
`

/**
 * ESS 삭제 (Soft Delete)
 */
export const deleteESSGQL = gql`
  mutation deleteESS($val: String!) {
    deleteESS(_id: $val) {
      _id
      deletedAt
    }
  }
`
